import tailwindConfig from '../../../../tailwind.config';

type Props = {
  size: number;
  color?: string;
};

const PlusCircle = ({ size, color = tailwindConfig.theme.colors.gray[600] }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 17V22.8478C17 22.9315 16.9053 23 16.7895 23H15.2105C15.0947 23 15 22.9315 15 22.8478V17H9.15217C9.06848 17 9 16.9053 9 16.7895V15.2105C9 15.0947 9.06848 15 9.15217 15H15V9.15217C15 9.06848 15.0947 9 15.2105 9H16.7895C16.9053 9 17 9.06848 17 9.15217V15H22.8478C22.9315 15 23 15.0947 23 15.2105V16.7895C23 16.9053 22.9315 17 22.8478 17H17Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28ZM16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30Z"
        fill={color}
      />
    </svg>
  );
};

export default PlusCircle;
